import {Component, inject, Input, OnDestroy} from '@angular/core';
import {User} from "../../interfaces/header-data";
import {AdminsRequisites, Contacts, InfoSupportRequisites} from "../../interfaces/contacts";
import {Delivery} from "../../interfaces/delivery";
import {takeUntil} from "rxjs/operators";
import {BaseService} from "../../services/base.service";
import {Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {LocalStorageService} from "../../services/local-storage.service";

@Component({
  selector: 'app-modal-contacts',
  templateUrl: './modal-contacts.component.html',
  styleUrls: ['./modal-contacts.component.scss']
})
export class ModalContactsComponent extends BaseService implements OnDestroy {
  @Input() user: User;
  @Input() contacts_drivers: string = '';
  @Input() delivery: Delivery[];
  @Input() admins_requisites: AdminsRequisites[];

  private http: HttpClient = inject(HttpClient);
  private localStorage: LocalStorageService = inject(LocalStorageService);

  isDestroyed: Subject<boolean> = new Subject<boolean>();
  isModalContactsShow: boolean = false;
  isDarkBackground: boolean = false;
  infoSupportRequisites: InfoSupportRequisites[];
  infoModalShow: boolean = false;

  openModalContactsShow() {
    this.closeModal();
    this.http.post(this.apiRoot + 'contact/data', {
      delivery_id: this.localStorage.get('delivery_id')
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: Contacts) => {
        if (data.data.delivery_info) {
          data.data.delivery_info = Object.values(data.data.delivery_info);
          this.delivery = data.data.delivery_info.map((val: Delivery) => {
            if (val.area_id !== null) {
              val.area_id = parseInt(val.area_id);
            }

            val.contacts = val.contacts.replaceAll('\n', '<br>');

            return val;
          });
        }

        if (data.data.info_support_requisites) {
          this.infoSupportRequisites = data.data.info_support_requisites.map((val: InfoSupportRequisites) => {
            val.value = val.value.replaceAll('\n', '<br>');

            return val;
          });
        }

        if (data.data.admins_requisites) {
          this.admins_requisites = data.data.admins_requisites.map((val) => {
            val.value = val.value.replaceAll('\n', '<br>');

            return val;
          });
        }

        if (data.data.contacts_drivers && data.data.contacts_drivers.length) {
          this.contacts_drivers = data.data.contacts_drivers[0].contacts.replaceAll('\n', '<br>');
        }
      });

    this.isModalContactsShow = true;
    this.isDarkBackground = true;
  }

  openInfoTelegramModal() {
    this.infoModalShow = true;
    this.isDarkBackground = true;
  }

  understand() {
    this.infoModalShow = false;
  }

  closeModal() {
    this.isModalContactsShow = false;
    this.infoModalShow = false;
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
